<template>
  <div class="product-grid-content">
    <router-link to="/cart">View Cart</router-link>

    <div class="container">
      <div class="row">
        <div
          v-for="product of products"
          :key="product.id"
          class="col-sm-6 col-lg-4"
        >
          <div class="product-grid">
            <div class="product-img justify-content-center align-items-center">
              <img :src="product.widget_image_portrait" class="img-fluid" />
            </div>
            <div class="product-info">
              <h3 class="title">
                <a href="#">{{ product.name }}</a>
              </h3>
              <h5 class="subtitle">Software</h5>
              <div class="d-flex justify-content-between">
                <div class="price">
                  {{ product.price }}
                </div>
                <div class>
                  <a
                    href="#"
                    class="btn"
                    @click="addProductToCart(product.id, product.method_id)"
                    >ADD TO CART</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /.End of product item -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "app",
  data() {
    return {
      products: [],
    };
  },
  async mounted() {
    const data = await axios.get("/api/v4/products?all=1");
    //console.log(data);
    this.products = data.data;
  },

  methods: {
    addProductToCart(productId, methodId) {
      this.$store.dispatch("addToCart", {
        productId: productId,
        methodId: methodId,
      });
    },
  },
};
</script>
